import {
  createContext,
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useContext,
  useMemo,
  useState
} from 'react';

interface Indicator {
  type: 'success' | 'warning';
  text: string;
}

interface DialogIndicatorContextValue {
  indicator: Indicator | null;
  setIndicator: Dispatch<SetStateAction<Indicator | null>>;
}

export const dialogIndicatorContextGlobal: Partial<
  Pick<DialogIndicatorContextValue, 'setIndicator'>
> = {};

const DialogIndicatorContext = createContext({} as DialogIndicatorContextValue);

export const DialogIndicatorContextProvider = (props: Required<PropsWithChildren<unknown>>) => {
  const [indicator, setIndicator] = useState<Indicator | null>(null);
  const contextValue = useMemo(() => ({ indicator, setIndicator }), [indicator]);
  dialogIndicatorContextGlobal.setIndicator = setIndicator;

  return <DialogIndicatorContext.Provider {...props} value={contextValue} />;
};

export const useDialogIndicatorContext = () => useContext(DialogIndicatorContext);
